import { animate, useReducedMotion } from 'framer-motion'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

import { EASE } from './tokens'

// Zahl, die beim Erscheinen und bei jeder Änderung vom alten Wert auf den
// neuen zählt. Bei reduzierter Bewegung steht der Wert sofort da.
const CountUp = ({ value, duration, className }) => {
  const reducedMotion = useReducedMotion()
  const [display, setDisplay] = useState(reducedMotion ? value : 0)
  const from = useRef(reducedMotion ? value : 0)

  useEffect(() => {
    if (reducedMotion) {
      setDisplay(value)
      from.current = value
      return undefined
    }
    const controls = animate(from.current, value, {
      duration,
      ease: EASE.out,
      onUpdate: (latest) => setDisplay(Math.round(latest))
    })
    from.current = value
    return () => controls.stop()
  }, [value, duration, reducedMotion])

  return <span className={className}>{display}</span>
}

CountUp.propTypes = {
  value: PropTypes.number.isRequired,
  duration: PropTypes.number,
  className: PropTypes.string
}

CountUp.defaultProps = {
  duration: 0.6,
  className: undefined
}

export default CountUp
